import $ from 'jquery';

$(function() {
    // Skip link script for focus
    // add tabindex attribute to the main section
    $("#main-content").attr("tabindex","-1");
     // bind click event to the skip link
    $("#skip-link").click(function(e) {
        // prevent default behavior of the link
        e.preventDefault();
        // move focus to the main section
        $("#main-content").focus();
    });
  });


// WEBPACK FOOTER //
// ./components/cwm-header/scripts/cwm-skip-link.js